<template>
    <div class="tab-content-container">
        <!--    General status    -->
        <div class="tab-header-container">
            <h2 class="form-label">Статус</h2>
            <LiteButton @click.native="editGeneralStatusClicked"
                        class="edit-button"
                        v-show="!shouldEditGeneralStatus"
                        :hoverColor="'blue'"
                        :icon="'far fa-edit'">
            </LiteButton>
            <LiteButton @click.native="editGeneralStatusClicked"
                        style="font-size: 27px;"
                        class="edit-button"
                        v-show="shouldEditGeneralStatus"
                        :hoverColor="'red'"
                        :icon="'far fa-window-close'">
            </LiteButton>
        </div>

        <hr class="form-line">

        <div  v-if="!shouldEditGeneralStatus && generalStatusHistory">
            <div class="item-container very-light-shadow"
                 v-for="generalStatus in generalStatusHistory"
                 :key="generalStatus.id"
                 :class="currentStatusClass(generalStatus)"
            >
                <p class="item-label" v-text="generalStatus.name"></p>

                <p class="item-label item-label-info" v-if="generalStatus.date">
                    Дата: {{generalStatus.date}}
                </p>

                <div class="last-modified-container">
                    <p class="last-modified-date" v-text="getLastModifiedDate(generalStatus)"></p>
                    <p class="last-modified-name" v-text="getLastModifiedBy(generalStatus)"></p>
                </div>
            </div>
        </div>

        <div class="change-general-status-container" v-if="shouldEditGeneralStatus">
            <SelectDropDown class="item-dropdown"
                            :id="'generalStatuses'"
                            :name="'generalStatuses'"
                            @selection-change="generalStatusSelected"
                            :options="nextStatuses"
                            :label="'Смяна на статус'"
                            :placeholder="'Изберете статус'">
            </SelectDropDown>

            <date-picker v-model="date"
                         type="date"
                         class="date-input"
                         :format="'DD-MM-YYYY'"
                         :disabled-date="(date) => this.workerGeneralStatus && this.workerGeneralStatus.date ? date <= new Date(this.workerGeneralStatus.date) : false"
                         :lang="{formatLocale: getFormatLocale()}"
                         placeholder="Изберете дата"/>

            <Button class="save-button"
                    @click.native="saveGeneralStatus"
                    :color="'green'"
                    :text="'Запази'"
                    :icon="'fa fa-save'"></Button>

        </div>

        <hr class="form-line" style="margin-top: 40px;">
    </div>
</template>

<script>
    import LiteButton from "@/shared/components/button/LiteButton";
    import {mapGetters} from 'vuex';
    import DatePicker from 'vue2-datepicker';
    import mapperService from "@/services/mapper.service";
    import SelectDropDown from "@/shared/components/form/SelectDropDown";
    import workerService from "@/services/worker.service";
    import Button from "@/shared/components/button/Button";
    import dateService from "@/services/date.service";

    export default {
        name: "WorkerStatuses",
        components: {Button, SelectDropDown, LiteButton, DatePicker},
        mounted() {
            if (this.workerGeneralStatus && this.workerGeneralStatus.id) {
                this.shouldEditGeneralStatus = false;
            }

            this.fetchNextStatuses();
        },
        data() {
            return {
                workerId: this.$route.params.id,
                shouldEditOperationalStatus: false,
                shouldEditGeneralStatus: true,
                nextStatuses: [],
                selectedGeneralStatus: null,
                date: null
            }
        },
        methods: {
            fetchNextStatuses() {
                workerService.fetchNextGeneralStatuses(
                    this.workerGeneralStatus && this.workerGeneralStatus.statusId ? this.workerGeneralStatus.statusId : 'none'
                )
                    .then(({data}) => {
                        this.nextStatuses = data;
                    });
            },
            editGeneralStatusClicked() {
                if (!this.shouldEditGeneralStatus) {
                    workerService.fetchNextGeneralStatuses(this.workerGeneralStatus ? this.workerGeneralStatus.statusId : 'none')
                        .then(({data}) => {
                            this.nextStatuses = data;
                            this.shouldEditGeneralStatus = true;
                        });
                } else {
                    this.shouldEditGeneralStatus = false;
                }
            },
            currentStatusClass(status) {
                if (this.workerGeneralStatus && this.workerGeneralStatus.id && status.id === this.workerGeneralStatus.id) {
                    return 'current-status';
                }
                return '';
            },
            getLastModifiedDate(object) {
                return mapperService.getLastModifiedDate(object);
            },
            getLastModifiedBy(object) {
                return mapperService.getLastModifiedBy(object);
            },
            generalStatusSelected(generalStatus) {
                this.selectedGeneralStatus = generalStatus.currentValue;
            },
            saveGeneralStatus() {
                if (this.selectedGeneralStatus) {
                    if (this.date) {
                        const tempDate = dateService.formatDateISO(this.date);
                        workerService.changeGeneralStatus(this.selectedGeneralStatus.id, this.workerId, tempDate)
                            .then(({data}) => {
                                this.$store.commit('setGeneralStatusHistory', data);
                                this.$store.commit('setWorkerGeneralStatus', data[0]);
                                this.shouldEditGeneralStatus = false;
                            });
                    }
                }
            },
            getFormatLocale() {
                return dateService.getFormatLocale();
            }
        },
        computed: {
            ...mapGetters(['workerGeneralStatus', 'generalStatusHistory'])
        },
        watch: {
            workerGeneralStatus: {
                handler(newVal) {
                    if (newVal) {
                        this.shouldEditGeneralStatus = false;
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
    .item-dropdown {
        width: 400px;
        float: left;
    }

    .change-general-status-container {
        width: 100%;
        display: inline-block;
    }

    .save-button {
        width: 200px;
        height: 60px;
        font-size: 26px;
        margin: 27px 50px;
        float: left;
    }

    .date-input {
        width: 250px;
        float: left;
        margin: 40px;
    }

    .current-status {
        border: 2px solid var(--slight-light-blue);
        box-sizing: border-box;
    }
</style>